"use client"

import {useEffect, useState} from 'react';
import {SearchFilters} from "@/types/Search";
import {useAppStore} from "@/store/AppStore";
import {postsRequest} from "@/utils/api/Posts";
import {Posts} from "@/types/Post";

const usePostsData = (searchFilters?: SearchFilters) => {
  const [data, setData] = useState<Posts | undefined>(undefined);
  const reload = useAppStore((state) => {
    return state.reloadSearch
  })
  const setReloadSearch = useAppStore((state) => {
    return state.setReloadSearch
  })

  useEffect(() => {
    const fetchData = async () => {
      const fetched = await postsRequest(searchFilters)
      if (fetched) {
        setData(fetched);
      }
      setReloadSearch(false)
    }
    if (!data || reload) {
      fetchData();
    }
  }, [data, searchFilters, reload, setReloadSearch]);

  return data;
};

export default usePostsData;
